import PropTypes from 'prop-types';
import {Navigate} from 'react-router-dom';
import {useAuthUser} from './AuthHooks';

const PublicRouteGuard = ({children}) => {
  const {isAuthenticated} = useAuthUser();
  if (isAuthenticated) {
    return <Navigate to='/dashboard' replace />;
  }
  return children;
};

PublicRouteGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PublicRouteGuard;
